import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerContractObjectsGql } from '../../ContractQueries';

const requestId = 'uerContractObjects';

export const useUerContractObjects = (contractId?: number, withEffect = false) => {
    const dispatch = useDispatch();

    const variables = useMemo(() => (withEffect && contractId ? { contractId } : undefined), [contractId, withEffect]);

    const [uerContractObjectsData, uerContractObjectsStatus, , uerContractObjectsRequest] = useRequest({
        requestId,
        query: uerContractObjectsGql,
        withEffect,
        variables,
    });

    const [uerContractObjectsReset] = useResetStoreData({ requestId });

    const uerContractObjectsMakeRequest = useCallback(
        (constructionTypeId: number) => {
            uerContractObjectsReset(undefined);
            dispatch(uerContractObjectsRequest({ contractId, constructionTypeId }));
        },
        [uerContractObjectsReset, dispatch, uerContractObjectsRequest, contractId],
    );

    return {
        uerContractObjectsMakeRequest,
        uerContractObjectsData,
        uerContractObjectsStatus,
    };
};
